import type {
  GetAllIncidenceTypesResponseT,
  IncidenceTypesMapperT,
} from "../types/incidenceTypes.types";
import type { IncidenceTypeResponseDtoT } from "../../domain/dtos/incidenceType.dto";
import type { IncidenceTypeEntityT } from "../../domain/entities/incidenceType.entity";

const mapItemToDomain = (item: IncidenceTypeResponseDtoT): IncidenceTypeEntityT => ({
  id: item.id,
  active: item.active ?? null,
  leaderUse: item.leaderUse ?? null,
  name: item.name ?? null,
  code: item.code ?? null,
  typeOfIncident: item.typeOfIncident ?? null,
  descriptionTypeOfIncident: item.descriptionTypeOfIncident ?? null,
  unitValue: item.unitValue ?? null,
  percentage: item.percentage ?? null,
  typeItConsiders: item.typeItConsiders ?? null,
  descriptionItConsiders: item.descriptionItConsiders ?? null,
  salaryRight: item.salaryRight ?? null,
  decreasesSeventhDay: item.decreasesSeventhDay ?? null,
  accummulatedTypes: item.accummulatedTypes ?? null,
});

export const incidenceTypesMapper: IncidenceTypesMapperT = {
  incidenceTypesDtoToDomain: (
    rawData: GetAllIncidenceTypesResponseT,
  ): IncidenceTypeEntityT[] => {
    const items: IncidenceTypeResponseDtoT[] = rawData?.results ?? [];

    return items.map(mapItemToDomain);
  },
};
